import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoCuentasPresu from '../../catalogos/catalogoCuentasPresupuestarias';

export const ImprimirListaXOrdenCompra = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [mostrar4, setMostrar4] = useState(false);
    const [valfech, setValfech] = useState(0);
    const [condi, setCondi] = useState(0);
    const [idcuent, setIdcuent] = useState(0);
    const [cata, setCata] = useState(0);
    const [valor1, setValor1] = useState('00');
    const [valor2, setValor2] = useState('00');
    const [valor3, setValor3] = useState('00');
    const [valor4, setValor4] = useState('00');
    const [valor5, setValor5] = useState('00');
    const [valor6, setValor6] = useState('000');
    const [valor7, setValor7] = useState('00');
    const [valor8, setValor8] = useState('00');
    const [valor9, setValor9] = useState('00');
    const [valor10, setValor10] = useState('0000');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtTodasCuentas = useRef();
    const txtCuenta = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const txtFechaHoy = useRef();
    const txtEntreFechas = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (condi === 1) {

            if (txtDesde.current.value === "") {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Desde no debe ir Vacio!', icono: 'informacion' });
                sigue = false;
                txtDesde.current.focus();
            } else if (txtHasta.current.value === "") {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Hasta no debe ir Vacio!', icono: 'informacion' });
                sigue = false;
                txtHasta.current.focus();
            } else {
                imprimirGeneral(desde, hasta, idcuent, cata, valfech, condi); 
            }

        } else if (sigue) {
            imprimirGeneral(desde, hasta, idcuent, cata, valfech, condi);
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'desde') {
            setDesde(e.target.value);
        } else if (e.target.id === 'hasta') {
            setHasta(e.target.value);
        }
    };

    const onCheck = () => {

        if (props.condicion === 'Compromisos X.Ctas Presupuestarias') {

            if (txtCuenta.current.checked) {
                setCata(1);
                setActivo(true);
                if (condi === 1) {
                    txtDesde.current.value = '';
                    txtHasta.current.value = '';
                }
            } else if (txtTodasCuentas.current.checked) {
                setActivo(false);
                setCata(0);
                if (condi === 1) {
                    txtDesde.current.value = '';
                    txtHasta.current.value = '';
                }
            }

            if (txtFechaHoy.current.checked) {
                setValfech(0);
                setCondi(0);
            } else if (txtEntreFechas.current.checked) {
                setValfech(1);
                setCondi(1);
            }

        }


    }

    const imprimirGeneral = (desde, hasta, idcuenta, cata, valfch, condi) => {

        var reporte = "";
        var sql = "";
        var sql1 = "";
        let desdec = '';
        let hastac = '';

        if (condi === 1) {
            desdec = moment.utc(desde).format('DD-MM-YYYY');
            hastac = moment.utc(hasta).format('DD-MM-YYYY');
        } else {
            desdec = moment.utc(fechaSistema).format('DD-MM-YYYY');
            hastac = moment.utc(fechaSistema).format('DD-MM-YYYY');
        }

        if (props.condicion === 'Compromisos X.Ctas Presupuestarias') {

            reporte = 'Pres_Comprometido';

            if (valfch !== 0) {
                sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";
            } else {
                sql1 = " EL DÍA" + " " + "'" + desdec ;
            }

            if (cata !== 0) {
                sql = "MOV.idcuenta = "+ idcuenta + " AND MOV.Fecha Between" + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            } else {
                sql = "MOV.Fecha Between" + "'" + desdec + "'"+ " AND " + "'" + hastac + "'";
            }          

        } else if (props.condicion === 'Listado de Ordenes de Pagos x Cuentas') {

            reporte = 'Pres_CuentasxOrden';

            if (cata === 1) {
                sql = "cuentapresupuestaria.idcuenta = "+ idcuenta;
            }

        }

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&idfiscal=" + idefiscal + "&sql=" + sql + "&sql1=" + sql1 + "&sql2=" + desdec + "&sql3=" + hastac, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        if (condi === 1) {
            txtDesde.current.value = '';
            txtHasta.current.value = '';
        }
        setActivo(true);
        setCata(0);
        setCondi(0);
        setValor1('00');
        setValor2('00');
        setValor3('00');
        setValor4('00');
        setValor5('00');
        setValor6('000');
        setValor7('00');
        setValor8('00');
        setValor9('00');
        setValor10('0000');
        setValfech(0);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const handleAceptaCuenta = (cuenta, descripcion, auxiliar, disponible, idcuenta) => {
        setMostrar4(false);
        setValor1(cuenta.substring(0, 2));
        setValor2(cuenta.substring(2, 4));
        setValor3(cuenta.substring(4, 6));
        setValor4(cuenta.substring(6, 8));
        setValor5(cuenta.substring(8, 11));
        setValor6(cuenta.substring(11, 13));
        setValor7(cuenta.substring(13, 15));
        setValor8(cuenta.substring(15, 17));
        setValor9(cuenta.substring(17, 19));
        setValor10(auxiliar);
        setActivo(false);
        setIdcuent(idcuenta);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {

                if (props.condicion === 'Listado de Ordenes de Pagos x Cuentas') {
                    setCata(1);
                } else {
                    setCata(0);
                }

                if (props.condicion === 'Compromisos X.Ctas Presupuestarias') {
                    txtFechaHoy.current.checked = true;
                    txtEntreFechas.current.checked = false;
                    setValfech(0);
                    setCondi(0);                
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir ' + props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoCuentasPresu
                    show={mostrar4}
                    onHideCancelar={handleCancelaras}
                    onHideAceptaClasPresupuestaria={handleAceptaCuenta}
                />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>


                                {props.condicion === 'Compromisos X.Ctas Presupuestarias' ? <div className='row m-0 col-sm-10 px-0 border-azul rounded py-2 mx-auto mb-2'>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtCuenta} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Seleccionar Cuenta
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtTodasCuentas} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Todos las Cuentas
                                        </label>
                                    </div>
                                </div> : ''}

                                {cata !== 0 ? <div className='col-md-12 m-0 px-0'>
                                    <table className="table">
                                        <thead>
                                            <tr className='text-center'>
                                                <th scope="col">Sector</th>

                                                <th scope="col">Prog</th>

                                                <th scope="col">SubProg</th>

                                                <th scope="col">Proyec</th>

                                                <th scope="col">Actv</th>

                                                <th scope="col">Part</th>

                                                <th scope="col">Gen</th>

                                                <th scope="col">Espec</th>

                                                <th scope="col">SubEspec</th>

                                                <th scope="col">Aux</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-bordered'>
                                            <tr className='text-center'>
                                                <td>{valor1}</td>

                                                <td>{valor2}</td>

                                                <td>{valor3}</td>

                                                <td>{valor4}</td>

                                                <td>{valor5}</td>

                                                <td>{valor6}</td>

                                                <td>{valor7}</td>

                                                <td>{valor8}</td>

                                                <td>{valor9}</td>

                                                <td>{valor10}</td>

                                                <td><button onClick={catalogoClass} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> : ''}

                                {props.condicion === 'Compromisos X.Ctas Presupuestarias' ? <div className='row m-0 col-sm-5 px-0 border-azul rounded py-2 mx-auto mb-2'>
                                    <div className="form-check col-md-3 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtFechaHoy} onChange={onCheck} type="radio" name="radioFech" id="radioFech1" />
                                        <label className="form-check-label" for="radioFech1">
                                            Hoy
                                        </label>
                                    </div>
                                    <div className="form-check col-md-6 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtEntreFechas} onChange={onCheck} type="radio" name="radioFech" id="radioFech2" />
                                        <label className="form-check-label" for="radioFech2">
                                            Entre Fechas
                                        </label>
                                    </div>
                                </div> : ''}

                                {valfech !== 0 ? <div className='row m-0 col-sm-8 px-0 border-azul rounded py-2 mx-auto mb-2'>

                                    <div className='col-sm-6 mb-1 px-1'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Desde Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesde} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desde" />
                                        </div>
                                    </div>

                                    <div className='col-sm-6 mb-1 px-1'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHasta} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hasta" />
                                        </div>
                                    </div>

                                </div> : ''}

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}